/**
 * IvCert
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';
import { AuthLoginRequest } from '../model/authLoginRequest';
import { AuthPasswordRecoveryRequest } from '../model/authPasswordRecoveryRequest';
import { AuthPasswordRecoveryResponse } from '../model/authPasswordRecoveryResponse';
import { AuthTokenCheckRequest } from '../model/authTokenCheckRequest';
import { AuthTokenCheckResponse } from '../model/authTokenCheckResponse';
import { CertCERGetRequest } from '../model/certCERGetRequest';
import { CertListAvailableRequest } from '../model/certListAvailableRequest';
import { CertPinCheckRequest } from '../model/certPinCheckRequest';
import { IvGenericRestResponseCertCERGetResponse } from '../model/ivGenericRestResponseCertCERGetResponse';
import { IvGenericRestResponseCertListAvailableResponse } from '../model/ivGenericRestResponseCertListAvailableResponse';
import { IvGenericRestResponseCertPinCheckResponse } from '../model/ivGenericRestResponseCertPinCheckResponse';
import { IvGenericRestResponseSignaturePadesResponse } from '../model/ivGenericRestResponseSignaturePadesResponse';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { DateParser } from "../date";
import { IvGenericRestResponseString } from '../model/ivGenericRestResponseString';
import { RequestBiometry } from '../model/requestBiometry';
import { RequestPades } from '../model/requestPades';
import { IvGenericRestResponseSignatureXadesResponse } from '../model/ivGenericRestResponseSignatureXadesResponse';
import { SignatureXadesRequest } from '../model/signatureXadesRequest';
import { Environment } from '../../models/environment';
import { PersonalizationsService } from '../../base/services/personalizations/personalizations.service';
import { EnvironmentService } from './environment.service';
import { PadesInitMFSRequest } from '../model/padesInitMFSRequest';
import { IvGenericRestResponsePadesInitMFSResponse } from '../model/ivGenericRestResponsePadesInitMFSResponse';
import { FinalizeDistributePadesMFSRequest } from '../model/finalizeDistributePadesMFSRequest';
import { IvGenericRestResponseDistributedPadesFinalizeResponse } from '../model/ivGenericRestResponseDistributedPadesFinalizeResponse';

@Injectable()
export class IvSignService {

    environment: Environment;
    protected basePath: string;
    protected apiVersion: string;
    public defaultHeaders = new HttpHeaders().set('timeClient', DateParser.parse(new Date()));
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration, private _personalization: PersonalizationsService, private _env: EnvironmentService) {
        this.environment = this._personalization.sendEnv;
        this.apiVersion = this._env.apiVersion;
        this.basePath = this.environment?.url_api;
        this.defaultHeaders = this.defaultHeaders.set('X-Request-ID', 'app-front');
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }

    }
    /**
     *
     *
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ivSignGetSigBio(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseString>;
    public ivSignGetSigBio(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseString>>;
    public ivSignGetSigBio(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseString>>;
    public ivSignGetSigBio(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling ivSignGetSigBio.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<IvGenericRestResponseString>(`${this.basePath}/api/${this.apiVersion}/IvSign/Auth/SigBio`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param request
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ivSignPostCertCerGet(request: CertCERGetRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseCertCERGetResponse>;
    public ivSignPostCertCerGet(request: CertCERGetRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseCertCERGetResponse>>;
    public ivSignPostCertCerGet(request: CertCERGetRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseCertCERGetResponse>>;
    public ivSignPostCertCerGet(request: CertCERGetRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling ivSignPostCertCerGet.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling ivSignPostCertCerGet.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvGenericRestResponseCertCERGetResponse>(`${this.basePath}/api/${this.apiVersion}/IvSign/Cert/Cerget`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param request
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ivSignPostCertListAvailable(request: CertListAvailableRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseCertListAvailableResponse>;
    public ivSignPostCertListAvailable(request: CertListAvailableRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseCertListAvailableResponse>>;
    public ivSignPostCertListAvailable(request: CertListAvailableRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseCertListAvailableResponse>>;
    public ivSignPostCertListAvailable(request: CertListAvailableRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling ivSignPostCertListAvailable.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling ivSignPostCertListAvailable.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvGenericRestResponseCertListAvailableResponse>(`${this.basePath}/api/${this.apiVersion}/IvSign/Cert/ListAvailable`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param request
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ivSignPostCertPinCheck(request: CertPinCheckRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseCertPinCheckResponse>;
    public ivSignPostCertPinCheck(request: CertPinCheckRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseCertPinCheckResponse>>;
    public ivSignPostCertPinCheck(request: CertPinCheckRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseCertPinCheckResponse>>;
    public ivSignPostCertPinCheck(request: CertPinCheckRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling ivSignPostCertPinCheck.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling ivSignPostCertPinCheck.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvGenericRestResponseCertPinCheckResponse>(`${this.basePath}/api/${this.apiVersion}/IvSign/Cert/Pincheck`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

        /**
     *
     *
     * @param requestPadesInit
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
        public ivSignPostInitSignMFSPades(requestPadesInit: PadesInitMFSRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponsePadesInitMFSResponse>;
        public ivSignPostInitSignMFSPades(requestPadesInit: PadesInitMFSRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponsePadesInitMFSResponse>>;
        public ivSignPostInitSignMFSPades(requestPadesInit: PadesInitMFSRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponsePadesInitMFSResponse>>;
        public ivSignPostInitSignMFSPades(requestPadesInit: PadesInitMFSRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

            if (requestPadesInit === null || requestPadesInit === undefined) {
                throw new Error('Required parameter requestPadesInit was null or undefined when calling ivSignPostInitSignMFSPades.');
            }

            if (authorization === null || authorization === undefined) {
                throw new Error('Required parameter authorization was null or undefined when calling ivSignPostInitSignMFSPades.');
            }

            let headers = this.defaultHeaders;
            if (authorization !== undefined && authorization !== null) {
                headers = headers.set('Authorization', String(authorization));
            }

            // to determine the Accept header
            let httpHeaderAccepts: string[] = [
                'application/json',
                'text/json',
                'application/xml',
                'text/xml'
            ];
            const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
            if (httpHeaderAcceptSelected != undefined) {
                headers = headers.set('Accept', httpHeaderAcceptSelected);
            }

            // to determine the Content-Type header
            const consumes: string[] = [
                'application/json',
                'text/json',
                'application/xml',
                'text/xml',
                'application/x-www-form-urlencoded'
            ];
            const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
            if (httpContentTypeSelected != undefined) {
                headers = headers.set('Content-Type', httpContentTypeSelected);
            }

            return this.httpClient.post<IvGenericRestResponsePadesInitMFSResponse>(`${this.basePath}/api/v3/IvSign/Distributed/PadesInitMFS`,
                requestPadesInit,
                {
                    withCredentials: this.configuration.withCredentials,
                    headers: headers,
                    observe: observe,
                    reportProgress: reportProgress
                }
            );
        }



    /**
     *
     *
     * @param request
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ivSignPostLogin(request: AuthLoginRequest, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public ivSignPostLogin(request: AuthLoginRequest, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public ivSignPostLogin(request: AuthLoginRequest, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public ivSignPostLogin(request: AuthLoginRequest, authorization?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling ivSignPostLogin.');
        }

        /**if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling ivSignPostLogin.');
        }*/

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/${this.apiVersion}/IvSign/Auth/Login`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param request
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ivSignPostPasswordRecovery(request: AuthPasswordRecoveryRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<AuthPasswordRecoveryResponse>;
    public ivSignPostPasswordRecovery(request: AuthPasswordRecoveryRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AuthPasswordRecoveryResponse>>;
    public ivSignPostPasswordRecovery(request: AuthPasswordRecoveryRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AuthPasswordRecoveryResponse>>;
    public ivSignPostPasswordRecovery(request: AuthPasswordRecoveryRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling ivSignPostPasswordRecovery.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling ivSignPostPasswordRecovery.');
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AuthPasswordRecoveryResponse>(`${this.basePath}/api/${this.apiVersion}/IvSign/Auth/PasswordRecovery`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

      /**
     *
     *
     * @param request
     * @param idOperation
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
      public ivSignPostSignAndFinalizeMFSPades(request: FinalizeDistributePadesMFSRequest, idOperation: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseDistributedPadesFinalizeResponse>;
      public ivSignPostSignAndFinalizeMFSPades(request: FinalizeDistributePadesMFSRequest, idOperation: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseDistributedPadesFinalizeResponse>>;
      public ivSignPostSignAndFinalizeMFSPades(request: FinalizeDistributePadesMFSRequest, idOperation: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseDistributedPadesFinalizeResponse>>;
      public ivSignPostSignAndFinalizeMFSPades(request: FinalizeDistributePadesMFSRequest, idOperation: string, authorization: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

          if (request === null || request === undefined) {
              throw new Error('Required parameter request was null or undefined when calling ivSignPostSignAndFinalizeMFSPades.');
          }

          if (idOperation === null || idOperation === undefined) {
              throw new Error('Required parameter idOperation was null or undefined when calling ivSignPostSignAndFinalizeMFSPades.');
          }

          if (authorization === null || authorization === undefined) {
              throw new Error('Required parameter authorization was null or undefined when calling ivSignPostSignAndFinalizeMFSPades.');
          }

          let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
          if (idOperation !== undefined && idOperation !== null) {
              queryParameters = queryParameters.set('idOperation', <any>idOperation);
          }

          let headers = this.defaultHeaders;
          if (authorization !== undefined && authorization !== null) {
              headers = headers.set('Authorization', String(authorization));
          }

          // to determine the Accept header
          let httpHeaderAccepts: string[] = [
              'application/json',
              'text/json',
              'application/xml',
              'text/xml'
          ];
          const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
          if (httpHeaderAcceptSelected != undefined) {
              headers = headers.set('Accept', httpHeaderAcceptSelected);
          }

          // to determine the Content-Type header
          const consumes: string[] = [
              'application/json',
              'text/json',
              'application/xml',
              'text/xml',
              'application/x-www-form-urlencoded'
          ];
          const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
          if (httpContentTypeSelected != undefined) {
              headers = headers.set('Content-Type', httpContentTypeSelected);
          }

          return this.httpClient.post<IvGenericRestResponseDistributedPadesFinalizeResponse>(`${this.basePath}/api/v3/IvSign/Distributed/SignAndFinalizePadesMFS`,
              request,
              {
                  params: queryParameters,
                  withCredentials: this.configuration.withCredentials,
                  headers: headers,
                  observe: observe,
                  reportProgress: reportProgress
              }
          );
      }

    /**
     *
     *
     * @param requestPades
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ivSignPostSignaturePades(requestPades: RequestPades, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseSignaturePadesResponse>;
    public ivSignPostSignaturePades(requestPades: RequestPades, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseSignaturePadesResponse>>;
    public ivSignPostSignaturePades(requestPades: RequestPades, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseSignaturePadesResponse>>;
    public ivSignPostSignaturePades(requestPades: RequestPades, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (requestPades === null || requestPades === undefined) {
            throw new Error('Required parameter requestPades was null or undefined when calling ivSignPostSignaturePades.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling ivSignPostSignaturePades.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvGenericRestResponseSignaturePadesResponse>(`${this.basePath}/api/${this.apiVersion}/IvSign/Signature/Pades`,
            requestPades,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    /**
     *
     *
     * @param request
     * @param authorization The authorization token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ivSignPostTokenCheck(request: AuthTokenCheckRequest, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<AuthTokenCheckResponse>;
    public ivSignPostTokenCheck(request: AuthTokenCheckRequest, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AuthTokenCheckResponse>>;
    public ivSignPostTokenCheck(request: AuthTokenCheckRequest, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AuthTokenCheckResponse>>;
    public ivSignPostTokenCheck(request: AuthTokenCheckRequest, authorization?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling ivSignPostTokenCheck.');
        }

        /**if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling ivSignPostTokenCheck.');
        }*/

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AuthTokenCheckResponse>(`${this.basePath}/api/${this.apiVersion}/IvSign/Auth/Tokencheck`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param requestBiometry
     * @param authorization The authorization token
     * @param apiVersion
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ivSignBiometrySignature(requestBiometry: RequestBiometry, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public ivSignBiometrySignature(requestBiometry: RequestBiometry, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public ivSignBiometrySignature(requestBiometry: RequestBiometry, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public ivSignBiometrySignature(requestBiometry: RequestBiometry, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (requestBiometry === null || requestBiometry === undefined) {
            throw new Error('Required parameter requestBiometry was null or undefined when calling ivSignBiometrySignature.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling ivSignBiometrySignature.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/${this.apiVersion}/IvSign/Biometry/BiometrySignature`,
            requestBiometry,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
    *
    *
    * @param request
    * @param authorization The authorization token
    * @param typeSignature
    * @param apiVersion
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public ivSignPostSignatureXades(request: SignatureXadesRequest, authorization: string, typeSignature?: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseSignatureXadesResponse>;
    public ivSignPostSignatureXades(request: SignatureXadesRequest, authorization: string, typeSignature?: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseSignatureXadesResponse>>;
    public ivSignPostSignatureXades(request: SignatureXadesRequest, authorization: string, typeSignature?: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseSignatureXadesResponse>>;
    public ivSignPostSignatureXades(request: SignatureXadesRequest, authorization: string, typeSignature?: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling ivSignPostSignatureXades.');
        }

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling ivSignPostSignatureXades.');
        }



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (typeSignature !== undefined && typeSignature !== null) {
            queryParameters = queryParameters.set('typeSignature', <any>typeSignature);
        }
        if (apiVersion !== undefined && apiVersion !== null) {
            queryParameters = queryParameters.set('api-version', <any>apiVersion);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<IvGenericRestResponseSignatureXadesResponse>(`${this.basePath}/api/${this.apiVersion}/IvSign/Signature/Xades`,
            request,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
         *
         *
         * @param orgaId
         * @param authorization The authorization token
         * @param idOperation
         * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
         * @param reportProgress flag to report request and response progress.
         */
    public ivSignPostLoginSAML(orgaId: string, authorization?: string, idOperation?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public ivSignPostLoginSAML(orgaId: string, authorization?: string, idOperation?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public ivSignPostLoginSAML(orgaId: string, authorization?: string, idOperation?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public ivSignPostLoginSAML(orgaId: string, authorization?: string, idOperation?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (orgaId === null || orgaId === undefined) {
            throw new Error('Required parameter orgaId was null or undefined when calling ivSignPostLoginSAML.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (orgaId !== undefined && orgaId !== null) {
            queryParameters = queryParameters.set('orgaId', <any>orgaId);
        }
        if (idOperation !== undefined && idOperation !== null) {
            queryParameters = queryParameters.set('idOperation', <any>idOperation);
        }

        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/${this.apiVersion}/IvSign/Auth/LoginSAML`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
